import TriggerList from './TriggerList';
import PageHeader from '../../components/PageHeader';
import RouterLink from '../../components/RouterLink';
import { Box } from '@material-ui/core';
import { appPermissions, useAccess } from '../../hooks/useAccess';

const TriggerStats = () => {
  const { hasPermission } = useAccess();

  return hasPermission(appPermissions.adminRole) &&
    hasPermission(appPermissions.triggerView) ? (
    <>
      <PageHeader title="Trigger Statistics" />
      <TriggerList />
    </>
  ) : (
    <Box>
      <div className="permission-error" style={{ color: '#777' }}>
        You do not have permissions. Please contact support.
      </div>
    </Box>
  );
};

export default TriggerStats;
